import '@/bootstrap'
import '../css/app.css'

import {createApp, h} from 'vue'
import {ZiggyVue} from 'ziggy-js'
import {createInertiaApp} from '@inertiajs/vue3'
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers'

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

createInertiaApp({
	resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
	setup({el, App, props, plugin}){
		return createApp({
			render: () => h(App, props)
		})
			.use(plugin)
			.use(ZiggyVue, Ziggy)
			.mount(el)
	},
	title: (title) => `${title} - MavaQR`,
	progress: {
		color: '#4B5563',
		showSpinner: true
	}
}).catch((e) => {
	console.error(e)
})
